/* Re-resolves "today" client-side in the shop timezone so Shopify's full-page cache
   can't freeze the day. data-shop-tz defaults to Europe/Dublin (Ireland-only client). */
if (!customElements.get('location-today-hours')) {
  class LocationTodayHours extends HTMLElement {
    connectedCallback() {
      this.apply();
    }

    apply() {
      const mode = this.dataset.mode === 'reveal' ? 'reveal' : 'highlight';
      if (mode === 'highlight' && this.dataset.highlightToday !== 'true') return;

      const todayName = this.weekdayName(this.dataset.shopTz);
      const rows = this.querySelectorAll('[data-day]');
      let matched = false;

      rows.forEach((row) => {
        const isToday = (row.getAttribute('data-day') || '').trim().toLowerCase() === todayName;
        if (isToday) matched = true;
        if (mode === 'reveal') {
          row.toggleAttribute('hidden', !isToday);
        } else {
          row.classList.toggle('location-hours-card__row--today', isToday);
        }
      });

      // Reveal mode summarises a single day, so hide the whole block when today has no row.
      if (mode === 'reveal') this.hidden = !matched;
    }

    /**
     * Current weekday, lowercased, for matching against data-day. Resolved in the
     * given IANA zone; falls back to the visitor's zone if it's missing or invalid.
     * @param {string} [timeZone]
     * @returns {string}
     */
    weekdayName(timeZone) {
      /** @param {Intl.DateTimeFormatOptions} options */
      const format = (options) =>
        new Intl.DateTimeFormat('en-GB', options).format(new Date()).toLowerCase();
      try {
        return format(timeZone ? { timeZone: timeZone, weekday: 'long' } : { weekday: 'long' });
      } catch (error) {
        return format({ weekday: 'long' });
      }
    }
  }

  customElements.define('location-today-hours', LocationTodayHours);
}
